var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "simple-form" }, [
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.comInfo.name || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.comInfo.no || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.orgTypeMap[_vm.comInfo.orgType] || ""))])
      ])
    ]),
    _vm._v(" "),
    _vm.comInfo.orgType == 1
      ? _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-2x" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.bizUnitTypeMap[_vm.comInfo.bizUnitType]))
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("div", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.getTransComLevel(_vm.comInfo.bizUnitLevel)))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.comInfo.regionName || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(6),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.comInfo.street || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(7),
      _vm._v(" "),
      _c("div", { staticClass: "form-value width-2x" }, [
        _c("span", [_vm._v(_vm._s(_vm.comInfo.contactName || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(8),
      _vm._v(" "),
      _c("div", { staticClass: "form-value width-2x" }, [
        _c("span", [_vm._v(_vm._s(_vm.comInfo.contactTel || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(9),
      _vm._v(" "),
      _c("div", { staticClass: "form-value width-2x" }, [
        _c("span", [_vm._v(_vm._s(_vm.comInfo.contactEmail || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(10),
      _vm._v(" "),
      _c("div", { staticClass: "form-value width-2x" }, [
        _c("span", [_vm._v(_vm._s(_vm.comInfo.realComCode || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center spacing" }, [
      _vm._m(11),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _vm.files != null
          ? _c(
              "div",
              { staticClass: "file-area clearfix" },
              _vm._l(_vm.files, function(file, index) {
                return _c("swb-file-item", {
                  attrs: {
                    disabled: "",
                    trackKey: index,
                    fileUuid: file.fileUuid,
                    fileBrowseUrl: file.fileBrowseUrl
                  }
                })
              })
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("业务单元类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务单元级别")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构地址")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("详细地址")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系人姓名")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系电子邮箱")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("实体公司编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构图片")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-204d661d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-204d661d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/ComDetail.vue
// module id = 1943
// module chunks = 1